import React from 'react';

import { useAthenaSessionQuery } from '../../graphql/athena/queries/Session';
import { PrivateRouteComponent } from '../PrivateRoute';
import LwcLeadsTable from './LwcLeadsTable';
import { SampleLayout } from './SampleLayout';

const LWC_DASHBOARD_NAME = 'lwc dashboard';

export const LwcBrokerageDashboard: React.FC & PrivateRouteComponent = () => {
  const { customerUuid, data, loading, error } = useAthenaSessionQuery();

  if (loading || error || !data) {
    return null;
  }

  return (
    <SampleLayout>
      <LwcLeadsTable agentCustomerUuid={customerUuid ?? ''} />
    </SampleLayout>
  );
};

LwcBrokerageDashboard.dashboardName = LWC_DASHBOARD_NAME;
LwcBrokerageDashboard.isAuthorized = () => true;

export default LwcBrokerageDashboard;
